var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"primary-fill","d":"M21.129,39.5l-5-5.719,2.276-2,2.729,3.16,8.8-9.882,2.289,2.082Z","transform":"translate(-5454.668 -21582.413)"}));
}

Check.defaultProps = {"viewBox":"-5438.543 -21557.359 16.097 14.445","className":"icon check"};

module.exports = Check;

Check.default = Check;
